<template>
  <ResourceView :entityId="$route.params.articleId" entityClass="Article">
  </ResourceView>
</template>


<script>
import ResourceView from "@/views/admin/machines/ResourceView.vue";

export default {
  name: "ViewArticleResources",
  components: {
    ResourceView,
  },

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style scoped></style>